var _rect, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 20 20",
    height: "36px",
    viewBox: "0 0 20 20",
    width: "36px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 20,
    width: 20
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "14.41,3.41 13,2 5,10 13,18 14.41,16.59 7.83,10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCarousel);
export default __webpack_public_path__ + "static/media/arrow_carousel.cabd7e9ba0ae141a1ad37bc388560cfd.svg";
export { ForwardRef as ReactComponent };